import axios from 'axios'
import * as Sentry from '@sentry/react'
import i18n from 'i18next'
import { handleUnauthorizedApiResponse } from '@/api/unauthorizedResponseHandler'

export const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL!}`,
  withCredentials: true,
  timeout: 7500
})

apiClient.interceptors.request.use(
  config => {
    const currentLanguage = i18n.language
    if (currentLanguage) {
      config.headers['accept-language'] = currentLanguage
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  response => response,
  error => {
    console.log('[API Client] Error:', error.response?.data)

    if (error.response?.status === 401) {
      handleUnauthorizedApiResponse(error.config?.url)
    }

    try {
      if (error.response?.status >= 500) {
        Sentry.captureException(error)
      }
    } catch {
      // do nothing
    }

    throw error
  }
)
